let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aWTKM")).then(() => parcelRequire('8S7YZ'));